new WOW().init();
var wows = document.getElementsByClassName('wow')
for (i = 0; i < wows.length; i++){
  wows[i].style.visibility ='hidden';
}

(function($) {
	
	$(document).ready(function() {	
	
		$('#newsletter_ca').submit(function (event) {
			event.preventDefault();
			
			Forms.checkEmptyRequiredCheckboxs();								
			Forms.checkIfNotValidExist();
				
			if(Forms.isValid) {
			
				var data = $( this ).serialize();
				
				$.post( v.ajaxurl, data, function (data) {
					$('.email-input').val('');
					var info = $('#newsletter_modal_ca');
					info.find('.title').text(data.title2);
					info.find('.text').text(data.msg);	
					info.modal('show');
				});
			}	
		});
			
		$( '#ri-grid' ).gridrotator( {
			rows			: 1,
			columns			: 6,
			animType	: 'fadeInOut',
			animSpeed	: 1000,
			interval	: 2500,
			step		: 1,
			w1024			: {
				rows	: 1,
				columns	: 6
			},
			
			w768			: {
				rows	: 2,
				columns	: 3
			},
			
			w480			: {
				rows	: 2,
				columns	: 3
			},
			
			w320			: {
				rows	: 2,
				columns	: 3
			},
			
			w240			: {
				rows	: 2,
				columns	: 3
			}				
		});	
		
		var lastScrollTop = 0,
			header = $('header.navbar'),
			body = $('body'),
			st = 0;
		
		$(window).scroll(function(event){

			// animacja nav-bar
			st = $(this).scrollTop();
			if(st > header.outerHeight()) {	
				
				if ( st > lastScrollTop ){
				    // downscroll
					header.css({'transform' : 'translateY(-'+header.outerHeight()+'px)'});
				} else {
					// upscroll 
					header.css({'transform' : 'translateY(0)'});;					 
				}
				
				lastScrollTop = st;	
			}
			
		});
		
		$( "#menu-sidebar-menu > li.menu-item-has-children a" ).click(function() {
			$( "#accordion > .panel-default > .panel-heading a" ).removeClass( "open" );
			$( this ).toggleClass( "open" );
		});
		
		$( "#accordion > .panel-default > .panel-heading a" ).click(function() {
			
			var $hasClass = false;
			if ($( this ).hasClass( "open" )) {
				$hasClass = true;
			}
			
			$( "#accordion > .panel-default > .panel-heading a" ).removeClass( "open" );
			
			if (!$hasClass) {
				$( this ).addClass( "open" );
			}
			
		}); 
	 
		$( "#menu-sidebar-menu > li.menu-item-has-children ul li a" ).on('click', function (e) { e.stopPropagation(); })
		$( "#menu-sidebar-menu > li:not(.menu-item-has-children) a" ).on('click', function (e) { e.stopPropagation(); })
		
		$( "#menu-sidebar-menu > li > ul > li" ).each(function() {
		  	
		  	if($( this ).hasClass( "active" )){
			  	$parent = $( this ).parent();
				$parent.addClass("in");
				$parent.parent().find('a').addClass("open");
			}
			
		});	
		
		
		$('.map-close').click(function(event) {
			event.preventDefault();	
				
			$(".map-infobox").removeClass("visible");
			$(this).addClass("hidden"); 
		});		
		
		$("#mapModal").on("shown.bs.modal", function () {
		    google.maps.event.trigger(map, "resize");
		});	
		
		$("#lineupModal").on("shown.bs.modal", function () {
		    $('.lineup-modal-slider').flexslider({
				controlNav: false,
				directionNav: true,  
				slideshowSpeed: 6000,				
			});
			
			var ce = $.cookie('events');
			var selectedCookieEvents = [];
			if(ce !== undefined) {
				var selectedCookieEvents = JSON.parse(ce);
			}
			
			$( ".likeit" ).each(function() {			 
				var curEvent = $(this).data( "event-id" );
				
				if ($.inArray( curEvent, selectedCookieEvents ) >= 0) {
					$(this).addClass('active');
				}
			});
				
		});	
		
		var $likeItButton = $( ".likeit" );
		if ( $likeItButton.length ) { 
			var curEvent = $likeItButton.data( "event-id" );
			var ce = $.cookie('events');
			var selectedCookieEvents = [];
			if(ce !== undefined) {
				var selectedCookieEvents = JSON.parse(ce);
			}
			
			if ($.inArray( curEvent, selectedCookieEvents ) >= 0) {
				$likeItButton.addClass('active');
			}
		}
		
		$(document).on("click", ".likeit", function() {
			
			event.preventDefault();		
					
			$(this).toggleClass("active");
			
			var ce = $.cookie('events');
			var curEvent = $(this).data( "event-id" );
			
			var selectedCookieEvents = [];
			
			if(ce !== undefined) {
				var selectedCookieEvents = JSON.parse(ce);
			}
			
			$(".events-item-container." + curEvent).toggleClass('active');
			
			if($(this).hasClass("active")) {			
				
				selectedCookieEvents.push(curEvent);				
				$.removeCookie('events');
				$.cookie('events', JSON.stringify(selectedCookieEvents), { expires: 30, path: '/' });
				
			} else {
				selectedCookieEvents.splice( $.inArray(curEvent,selectedCookieEvents) ,1 );
				$.removeCookie('events');
				$.cookie('events', JSON.stringify(selectedCookieEvents), { expires: 30, path: '/' });
			}
						
		});		
		
		$('.btn-scroll-down').bind('click', function(event) {
			var $anchor = $(this);
			$('html, body').stop().animate({
            	scrollTop: $($anchor.attr('href')).offset().top - $( "header.navbar" ).height()
        		}, 500, 'swing');
				event.preventDefault();
    	});
		
		
		$('.go-up').click(function(event) {
			event.preventDefault();
			
			
			var body = $("html, body");
			body.stop().animate({
				scrollTop: 0
			}, 500, 'swing');			
			
			return false;
		});

		
		$('.user-nav .search, .nav-expander-icon.search').click(function(e){
			
			e.preventDefault();
			
		    var $this = $('.for-panel-search span.clickable');		    
		    var $helper = $('.for-panel-search');
		    var $second = $('.for-panel-user span.clickable');
		    var $secondHelper = $('.for-panel-user');
		    
		    if(!$second.hasClass('panel-collapsed')) {				
				$second.parents('.panel').find('.panel-body').slideUp();
				$second.addClass('panel-collapsed');				
				setTimeout(function(){
				    $secondHelper.fadeOut( "slow" );
				    $helper.fadeIn( "fast" );
					$this.parents('.panel').find('.panel-body').slideDown();
					$this.removeClass('panel-collapsed');		
			    }, 500);	 		   
			}else {
				if(!$this.hasClass('panel-collapsed')) {				
					$this.parents('.panel').find('.panel-body').slideUp();
					$this.addClass('panel-collapsed');
					
					
					setTimeout(function(){
				       $helper.fadeOut( "slow" );
				       $('body').removeClass('modal-open');
				   }, 500);
				   
				} else {
					$helper.fadeIn( "slow" );
					$('body').addClass('modal-open');
					$this.parents('.panel').find('.panel-body').slideDown();
					$(".orig").focus();
					$this.removeClass('panel-collapsed');
				}
			}
			
		});
		
		$('.for-panel-search').click(function(e){
			
			if (e.target !== this)
			return;
			
			var $helper = $('.for-panel-search span.clickable');
		    var $this = $(this);
			$helper.parents('.panel').find('.panel-body').slideUp();
			$helper.addClass('panel-collapsed');
			
			
			setTimeout(function(){
		       $this.fadeOut( "slow" );
		       $('body').removeClass('modal-open');
		   }, 500);			
			
		});		
		
		
		$('.user-nav .user, .nav-expander-icon.user, a.login-toggle').click(function(e){
			
			e.preventDefault();
			
		    var $this = $('.for-panel-user span.clickable');
		    var $helper = $('.for-panel-user');
		    var $second = $('.for-panel-search span.clickable');
		    var $secondHelper = $('.for-panel-search');
		    
			if(!$second.hasClass('panel-collapsed')) {				
				$second.parents('.panel').find('.panel-body').slideUp();
				$second.addClass('panel-collapsed');				
				setTimeout(function(){
				    $secondHelper.fadeOut( "slow" );
				    $helper.fadeIn( "fast" );
					$this.parents('.panel').find('.panel-body').slideDown();
					$this.removeClass('panel-collapsed');		
			    }, 500);	 		   
			}else {
				if(!$this.hasClass('panel-collapsed')) {				
					$this.parents('.panel').find('.panel-body').slideUp();
					$this.addClass('panel-collapsed');
					
					
					setTimeout(function(){
				       $helper.fadeOut( "slow" );
				       $('body').removeClass('modal-open');
				   }, 500);
				   
				} else {
					$helper.fadeIn( "slow" );
					$('body').addClass('modal-open');
					$this.parents('.panel').find('.panel-body').slideDown();
					$this.removeClass('panel-collapsed');
				}
			}
		});
		
		$('.for-panel-user').click(function(e){
			
			if (e.target !== this)
			return;
			
			var $helper = $('.for-panel-user span.clickable');
		    var $this = $(this);
			$helper.parents('.panel').find('.panel-body').slideUp();
			$helper.addClass('panel-collapsed');
			
			
			setTimeout(function(){
		       $this.fadeOut( "slow" );
		       $('body').removeClass('modal-open');
		   }, 500);			
			
		});
		
		
		$(window).scroll(function () {
		    if ($(document).scrollTop() > 500 ) {			    	       	
		        	
		        $('.go-up').addClass('visible-go-up');	        
		        
		    } else {
			    
			    $('.go-up').removeClass('visible-go-up');	
		        			     
		    }
		});
		
		loadGallery(true, 'a.thumbnail-custom');

	    //This function disables buttons when needed
	    function disableButtons(counter_max, counter_current){
	        $('#show-previous-image, #show-next-image').show();
	        if(counter_max == counter_current){
	            $('#show-next-image').hide();
	        } else if (counter_current == 1){
	            $('#show-previous-image').hide();
	        }
	    }
	
	    /**
	     *
	     * @param setIDs        Sets IDs when DOM is loaded. If using a PHP counter, set to false.
	     * @param setClickAttr  Sets the attribute for the click handler.
	     */
	
	    function loadGallery(setIDs, setClickAttr){
	        var current_image,
	            selector,
	            counter = 0;
	
	        $('#show-next-image, #show-previous-image').click(function(){
	            if($(this).attr('id') == 'show-previous-image'){
	                current_image--;
	            } else {
	                current_image++;
	            }
	
	            selector = $('[data-image-id="' + current_image + '"]');
	            updateGallery(selector);
	        });
	
	        function updateGallery(selector) {
	            var $sel = selector;
	            current_image = $sel.data('image-id');
	            $('#image-gallery-caption').text($sel.data('caption'));
	            $('#image-gallery-title').text($sel.data('title'));
	            $('#image-gallery-image').attr('src', $sel.data('image'));
	            disableButtons(counter, $sel.data('image-id'));
	        }
	
	        if(setIDs == true){
	            $('[data-image-id]').each(function(){
	                counter++;
	                $(this).attr('data-image-id',counter);
	            });
	        }
	        $(setClickAttr).on('click',function(){
	            updateGallery($(this));
	        });
	    }
		
		
		
		
		
        $('img.svg').each(function(){
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                
                               
                var $svg = jQuery(data).find('svg');
				$svg = $svg.remove('style');
                
//                 console.log( $svg );
                

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');
               

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        }); // img.svg
        
        
        $('.single-job #career-subject').val( 'Ogłoszenie: ' + $('.type-job h1').text() );

      
        
		$('.file-cv input').change(function () {
			var $txt = $( this ).parents('.file-cv').find('.txt');
			var $this = $( this );
			
			
			$txt.html( $this.val() ? $this.val().replace(/C:\\fakepath\\/i, '') : 'Wstaw załącznik' )
			
			console.log( $this );
		});
		
		
		
		$('.tab-content a[href$=".jpg"]').click(function (event) {
			event.preventDefault();
			
			var $this = $( this );
			
			var url = $this.attr('href');
			lity( url );
			
		});

		
		lightbox.option({
		  'albumLabel':  "%1/%2"
		});
		
		
		

		
		var bodyWidth = $( window ).width();
		if( bodyWidth > 1200) {
			var $halfslider_animation = "slide";
		} else {
			var $halfslider_animation = "fade";
		}   
		
		if($halfSliders.length > 0)
		{
			for(var i = 0; i < $halfSliders.length; i++)
			{
				var thisSlider = $halfSliders[i];
				$('.halfslider' + thisSlider).flexslider({
					animation: $halfslider_animation,
					slideshowSpeed: 4000, 
					animationSpeed: 700, 
					pauseOnHover: false,
					touch: true,
					smoothHeight: true,
					controlsContainer: $(".nav-container-halfslider"),
					after:  function(slider){
						 
						var current = slider.find(".flex-active-slide");
						
						var currentContent = current.data("from_slide");
						
						$(currentContent).css("opacity", "1");
						$(currentContent).html(current.data("slide_text"));  
						slider.flexslider('pause');
						slider.flexslider('play');
					},
					before:  function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide");
						 
						
						if(!slider.hasClass("no-animation"))
							$(currentContent).css("opacity", "0");
						
					}, 
					start: function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide"); 
						$(currentContent).html(current.data("slide_text"));  
					}
				  });
 
			} 
			$(".half-prev").click(function(e) {
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
				console.log(currentContent);
				$('.halfslider'+ currentContent).flexslider('prev');
				
			});
			$(".half-next").click(function(e) { 
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
				 
				$('.halfslider'+ currentContent).flexslider('next');
				
			});
		}
		
		
		
		$(".search-form button").click(function(e) {
			var $field = $(".search-field");
			if($field.css('opacity') == "0") {
				$field.css('opacity', "1");
				$field.css('width', "130px");
				e.preventDefault();
			}
			if($field.val() == "")
			{
				e.preventDefault();
			}
		}); 
		
		$('#nav-expander').on('click',function(e){
      		e.preventDefault();
      		
      		//zamknij search albo user
      		var $search = $('.for-panel-search span.clickable');		    
		    var $searchHelper = $('.for-panel-search');
		    var $user = $('.for-panel-user span.clickable');
		    var $userHelper = $('.for-panel-user');
		    
		    if(!$search.hasClass('panel-collapsed')) {	
			    			
				$search.parents('.panel').find('.panel-body').slideUp();
				$search.addClass('panel-collapsed');
				$searchHelper.fadeOut( "slow" );
				$('body').removeClass('modal-open');
				
			}
			
			if(!$user.hasClass('panel-collapsed')) {	
			    			
				$user.parents('.panel').find('.panel-body').slideUp();
				$user.addClass('panel-collapsed');	
		        $userHelper.fadeOut( "slow" );
		        $('body').removeClass('modal-open');
			   		   
			}
			
      		$('body').toggleClass('nav-expanded');
      	});            	
      	
      	$('.nav-expander-close').on('click',function(e){
      		e.preventDefault();
      		$('.menu-mobile2-container').removeClass('open');
      		$('body').removeClass('nav-expanded');
      	}); 
      	
      	$('.mobile2-switcher').on('click',function(e){
      		e.preventDefault();
      		$('.menu-mobile2-container').addClass('open');
      	});
      	
      	$('.mobile2-close').on('click',function(e){
      		e.preventDefault();
      		$('.menu-mobile2-container').removeClass('open');
      	});
      	
      	$('.nav-expander-icon.search').on('click',function(e){
      		e.preventDefault();
      		$('.menu-mobile2-container').removeClass('open');
      		$('body').removeClass('nav-expanded');
      	});
      	
      	$('.nav-expander-icon.user').on('click',function(e){
      		e.preventDefault();
      		$('.menu-mobile2-container').removeClass('open');
      		$('body').removeClass('nav-expanded');
      	}); 
      	
      	//mobile sidebar przewodnik      	
      	$('.sidebar-expander').on('click',function(e){
      		e.preventDefault();
      		$('body').toggleClass('sidebar-expanded');
      	});      	
      	
      	$('.sidebar-expander-close').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('sidebar-expanded');
      		$('.menu-sidebar-mobile-menu-2-container').removeClass('open');
      	}); 
      	
      	$('.sidebar2-switcher').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-2-container').addClass('open');
      	});
      	
      	$('.sidebar2-close').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-2-container').removeClass('open');
      	});
      	
      	//mobile sidebar wejsciowki  
      	$('.sidebar3-switcher').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-3-container').addClass('open');
      	});
      	
      	$('.sidebar3-close').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-3-container').removeClass('open');
      	});
      	
      	//mobile sidebar program  
      	$('.sidebar4-switcher').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-4-program-container').addClass('open');
      	});
      	
      	$('.sidebar4-close').on('click',function(e){
      		e.preventDefault();
      		$('.menu-sidebar-mobile-menu-4-program-container').removeClass('open');
      	});
      	
      	//mobile sidebar gallery
      	$('.sidebar-expander-gallery').on('click',function(e){
      		e.preventDefault();
      		$('body').addClass('sidebar-expanded-gallery');
      	});      	
      	
      	$('.sidebar-expander-gallery-close').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('sidebar-expanded-gallery');
	  		$('.term-children').removeClass('open');
      	}); 
      	
      	//mobile sidebar archive
      	$('.sidebar-expander-archive').on('click',function(e){
      		e.preventDefault();
      		$('body').addClass('sidebar-expanded-archive');
      	});      	
      	
      	$('.sidebar-expander-archive-close').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('sidebar-expanded-archive');
	  		$('.term-children').removeClass('open');
      	});
      	
      	//mobile sidebar events
      	$('.sidebar-expander-events').on('click',function(e){
      		e.preventDefault();
      		$('body').addClass('sidebar-expanded-events');
      	});      	
      	
      	$('.sidebar-expander-archive-events').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('sidebar-expanded-events');
	  		$('.term-children').removeClass('open');
      	}); 
      	
      	//mobile sidebar guests
      	$('.sidebar-expander-guests').on('click',function(e){
      		e.preventDefault();
      		$('body').addClass('sidebar-expanded-guests');
      	});      	
      	
      	$('.sidebar-expander-archive-guests').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('sidebar-expanded-guests');
	  		$('.term-children').removeClass('open');
      	}); 
      	
      	
      	//for all terms sidebars
      	$('.terms-slide-right .term-parent').on('click',function(e){
      		e.preventDefault();
      		
      		var slide = $(".terms-slide-right");
			slide.stop().animate({
				scrollTop: 0
			}, 200, 'swing');
      		
      		var term_id = $(this).attr("data-term-id");
      		$('#'+term_id).addClass('open');      		
      		
      	});
      	
      	$('.terms-slide-right .sub-menu li:first-of-type').on('click',function(e){
      		e.preventDefault();      		
      		$('.term-children').removeClass('open');
      	});
      	
      	
		var Slider = {
			init: function() {
				$('.slider-section').flexslider({
					controlNav: true,
					directionNav: true,  
					slideshowSpeed: 6000,				
				});	
				
				$('.partners-section').flexslider({
					controlNav: true,
					directionNav: false,  
					manualControls: ".partners-nav li",
					slideshowSpeed: 4000,	
					animation: "slide",
				});	
				
				$('.event-slider').flexslider({
					controlNav: false,
					directionNav: true, 	
					animation: "slide",
				});	
				
				$('.laureates-slider').flexslider({
					controlNav: false,
					directionNav: true, 	
					animation: "slide",
					itemWidth: 260,
					itemMargin: 0
				});
			}
		}
		Slider.init();
		
      	var Forms = {
	      	clickedButton: false,
	      	isValid: true,
			init: function() {
				
				setInterval(
					function(){
						$.ajax({
							type: "GET",
							url: v.ajaxurl,
							data: {}
						});	
					}
				, 180000);
				
				//test
// 				Forms.testForm(); 
				
				//helpers			
				$(document).on("focus", "input, textarea", Forms.onFocus);
				$(document).on("change", "input, textarea", Forms.checkFocus);
				$(document).on("click", ".datepicker", Forms.onClickDatepicker);
				$(document).on("focusout", "input:not(.datepicker)", Forms.onFocusOut);
				$(document).on("click", ".add-next-group", Forms.onAddNextGroup);
				$(document).on("click", ".add-next-group-in-group", Forms.onAddNextGroupInGroup);
				$(document).on("click", ".remove-group", Forms.onRemoveGroup);				
				$(document).on("change", '.new-ui-form input.choice[type="radio"]', Forms.onRadioChoice);
				$(document).on("click", 'button[type="submit"]', Forms.onClickSubmitButton);
				$(document).on("click", '.form-blocker', Forms.onClickBlocker);
				
				//validation	
				$(document).on("change", '.new-ui-form select', Forms.onSelectChange);	
				$(document).on("change", '.new-ui-form input[type="radio"]', Forms.onRadioChange);	
				$(document).on("change", '.new-ui-form input[type="checkbox"]', Forms.onCheckboxChange);			
				$(document).on("keyup", '.new-ui-form input[type="text"]', Forms.onInputTextChange);
				$(document).on("change", '.new-ui-form input[type="text"]', Forms.onInputTextChange);
				$(document).on("keyup", '.new-ui-form input[type="email"]', Forms.onInputEmailChange);
				$(document).on("change", '.new-ui-form input[type="email"]', Forms.onInputEmailChange);
				$(document).on("keyup", '.new-ui-form input[type="number"]', Forms.onInputNumberChange);
				$(document).on("change", '.new-ui-form input[type="number"]', Forms.onInputNumberChange);
				$(document).on("keyup", '.new-ui-form input.phone[type="text"]', Forms.onInputPhoneChange);
				$(document).on("change", '.new-ui-form input.phone[type="text"]', Forms.onInputPhoneChange);
// 				$(document).on("keyup", '.new-ui-form input.website[type="text"]', Forms.onInputWebsiteChange);
				$(document).on("change", '.new-ui-form input.website[type="text"]', Forms.onInputWebsiteChange);
				$(document).on("change", '.new-ui-form input[type="file"]', Forms.onInputFileChange);
				$(document).on("keyup", '.new-ui-form input.password[type="password"]', Forms.onInputPasswordChange);
				$(document).on("change", '.new-ui-form input.password[type="password"]', Forms.onInputPasswordChange);
				$(document).on("keyup", '.new-ui-form input.repeat-password[type="password"]', Forms.onInputRepeatPasswordChange);
				$(document).on("change", '.new-ui-form input.repeat-password[type="password"]', Forms.onInputRepeatPasswordChange);  
				
				//submit		
				$("#registerForm, #change-password-form, #movies-video-form, #homestay-student-form, #homestay-host-form, #pilots-form, #volunteer-form, #feature-film-form, #poland-film-form, #students-film-form").on("submit", Forms.onSubmitForm);
				$("#edit-user-form").on("submit", Forms.onSubmitEditUserForm);
				$("#talent-demo-form, #payment-form").on("submit", Forms.onSubmitPaymentForm);
				
				$("#form-login").on("submit", Forms.onLogin);
				
				
				$("#password-reset").on("submit", Forms.onResetPassword);
				//init
// 				$('.new-ui-form select').selectpicker();


				$( ".datepicker" ).datepicker({
					changeYear: true,
					yearRange: "-100:+0",
					onClose: function(dateText) {
						var label = $('label[for="'+$(this).attr('id')+'"]');
						if( $(this).val() ) {
							label.addClass("on-focus");							
						} else {
							label.removeClass("on-focus");
							$(this).removeClass("valid");
							if($(this).hasClass("required")) {
								$(this).addClass("not-valid");
							}
						}					
					},
					onSelect: function(dateText) {
						$(this).removeClass("not-valid").addClass("valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					}	
				});		
				
				$( ".datepicker" ).datepicker( "option",  $.datepicker.regional[ $( "input[name='locale']" ).val() ] );
				$( ".datepicker" ).datepicker( "option", "dateFormat", "yy-mm-dd" );
				$( ".currentdate" ).datepicker( "setDate", $( ".currentdate" ).data("date") );
										    
			    $(document).find(".new-ui-form select").selectpicker('render');
				
				
			},
			testForm: function() {
				$("input").each(function(e) {
			        
			        switch($(this).attr("type")) {
			            case "text": 
			                $(this).val("test " + $(this).attr("name"));
			                break;
			            case "email":
			                $(this).val("email@email.email");
			                break; 
			            case "date":
			                $(this).val("2016-10-15");
			                break; 
			            case "number":
		                $(this).val("6");
		                break;
					}
			    });
			    
			    $("input.phone").each(function(e) {
			        $(this).val("123456789");          
			    });
			    
			    $("input[type=radio]").each(function(e) {				    
			        $("input[name='"+$(this).attr('name')+"']").first().attr('checked', 'checked');         
			    });
			    
			    
			    
			    $("input[type=checkbox]").each(function(e) {
			        $(this).attr('checked','checked');         
			    });			   
			    
			    $("select").each(function(e) { 
			        $(this).find("option:nth(1)").attr('selected','selected');
			    });
			    
			    $("input.datepicker").each(function(e) {
			        $(this).val("10/10/2016");          
			    });

			},
			onLogin: function(e) {
				
				e.preventDefault();	
				
				$.ajax({
					type: "POST",
					url: v.ajaxurl,
					data: $(this).serialize(),
					success: function(data) {
						if(data.status == 200) {
							location.reload();
						} else {
							$("#logerror").html(data.message);
						}
						 
					}
				});	
				
				
			},
			
			onResetPassword: function(e) {
				
				e.preventDefault();	
				
				$.ajax({
					type: "POST",
					url: v.ajaxurl,
					data: $(this).serialize(),
					success: function(data) {
						if(data.status == 200) {
							$("#msg-success").html(data.data);
							 
						} else {
							$("#msg-error").html(data.message);
						}
						 
					}
				});	
				
				
			},
			onClickBlocker: function() {
				var $scroll = $(this).data("scroll");
				$(".ticket-type-container .label-focused").addClass("color-not-valid");
				$('html, body').stop().animate({						
	            	scrollTop: $("."+$scroll).offset().top - ($( "header.navbar" ).height() + 50)
        		}, 500, 'swing');
			},
			onClickDatepicker: function(e) {
				$(this).datepicker("show");
			},	
			onSelectChange: function(e) {
				$container = $(this).data("other");
				if ( !$(this).val() ){	
					$("#"+$container).slideUp();	
					if($(this).hasClass("required")) {
						$msgTextEmpty = $('#msg-text-empty').data("message");
						$(this).siblings("button").addClass("not-valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgTextEmpty);
					}			
					
				} else {					
					$(this).siblings("button").removeClass("not-valid").addClass("valid");
					$(this).removeClass("not-valid").addClass("valid");
					$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					
					if ( $(this).val() == "other" ){						
						$("#"+$container).slideDown();
					}else {
						$("#"+$container).slideUp();
					}	
				}
			},
			onRadioChange: function() {
				if( $("input[name='"+$(this).attr('name')+"']:checked").val() ) {
					$msgContainer = $(this).siblings(".label-focused").find(".validation-message");
					$msgContainer.html("").removeClass("not-valid");
				}	
			},
			onCheckboxChange: function() {
				$this = $(this);
				var $msgContainer = $(this).siblings(".label-focused").find(".validation-message");
				
				if( $this.attr('checked') ) {					
					$msgContainer.html("").removeClass("not-valid");
				} else {
					$msgRadioEmpty = $msgContainer.data("message");
					$msgContainer.html($msgRadioEmpty).addClass("not-valid");;
				}	
				
				if( $this.hasClass("copy") && $this.attr('checked') ) {
					$baseContainer = $this.data("base");
					$SourceContainer = $this.data("source");	
					
					$('#' + $SourceContainer + ' :input:visible').each(function(){	
				    	
				    	$type = $(this).data("type");
				    	
				    	$baseField = $(this).data("copy");
				    	$baseValue = $("#"+$baseField).val();
				    	
				    	if($type != "select") {
					    	if( $baseValue ) {
						    	$(this).val($baseValue).trigger("change");
					    	}
				    	} else {
					    	$other = $(this).data("other");
					    	$otherValue = $("#"+$other).val();
					    	
					    	if( $otherValue ) {						    	
						    	$(this).val($otherValue).trigger("change");
					    	} else {
						    	$selectedValue = $("#"+$baseField).find("option:selected").text();
						    	$(this).val($selectedValue).trigger("change");
					    	}
				    	}
				    	
				    	
				    	
					});
					
					$('#' + $SourceContainer).find("select").selectpicker('render');

				}
			},
			onRadioChoice: function() {
				$this = $(this);
				$cur = $("input[name='"+$(this).attr('name')+"']:checked").val();
				$container = $(this).data("for");				
				$("."+$container+" > .choice.open").slideUp();				
				$("."+$container+" > .choice_"+$cur).addClass("open").slideDown();
				$(".form-blocker").fadeOut();
				$(".ticket-type-container .label-focused").removeClass("color-not-valid");
				
				if($this.hasClass("ticket_type")) {
					$val = $this.val();
					$requireContainer = $this.data("require");
	
					if($val == 16 || $val == 20) {
						$("."+$requireContainer).find(":input").removeClass("required not-valid");
						$("."+$requireContainer).find(".validation-message").fadeOut("fast");						
						$("."+$requireContainer).find("label span").fadeOut("fast");
						$(document).find("."+$requireContainer+" "+".btn-group.bootstrap-select").removeClass("required");						
						
					} else {
						$("."+$requireContainer).find(":input:not(.not-required)").addClass("required");
						$("."+$requireContainer).find("label span").fadeIn("fast");
						$(document).find("."+$requireContainer+" "+".btn-group.bootstrap-select").addClass("required");
					}
					

				}
			},
			onFocus: function() {
				var label = $('label[for="'+$(this).attr('id')+'"]');
				label.addClass("on-focus");
			},
			checkFocus: function() {
				
				var label = $('label[for="'+$(this).attr('id')+'"]');
				if ( $(this).val() ){					
					label.addClass("on-focus");					
				} else {
					label.removeClass("on-focus");
				}
				
			},
			onFocusOut: function() {				
				if ( !$(this).val() ){
					var label = $('label[for="'+$(this).attr('id')+'"]');
					label.removeClass("on-focus");
				} 	
			},
			onInputTextChange: function() {
				$this_val = $(this).val();
				if($(this).is('.camel-case')) {
					$(this).val($this_val.charAt(0).toUpperCase() + $this_val.slice(1));
				}
				
				if($(this).is('.required')) {
					if( $this_val.length ) {
						$(this).removeClass("not-valid").addClass("valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					} else {
						$(this).removeClass("valid").addClass("not-valid");
						$msgTextEmpty = $('#msg-text-empty').data("message");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgTextEmpty);
					}
				} else {
					if( $this_val.length ) {
						$(this).addClass("valid");
					} else {
						$(this).removeClass("valid");
					}
				}
			},
			onInputPasswordChange: function() {
				if($(this).is('.required')) {
					if( $(this).val().length >= 6 ) {
						$(this).removeClass("not-valid").addClass("valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					} else {
						$(this).removeClass("valid").addClass("not-valid");
						$msgPswFormat = $('#msg-password-format').data("message");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgPswFormat);
					}
				} else {
					$(this).removeClass("valid").removeClass("not-valid");
				}
			},
			onInputRepeatPasswordChange: function() {
				if($(this).is('.required')) {
					$basePassword = $(this).data("for");
					if( $("#"+$basePassword).val() == $(this).val() ) {
						$(this).removeClass("not-valid").addClass("valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					} else {
						$(this).removeClass("valid").addClass("not-valid");
						$msgPswRepeat = $('#msg-repeat-password-format').data("message");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgPswRepeat);
					}
				} else {
					$(this).removeClass("valid").removeClass("not-valid");
				}
			},
			onInputEmailChange: function() {
				var $val = $(this).val();		
		        var expression = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,20}$/;
		
		        if(expression.test($val)) {
		            $(this).removeClass("not-valid").addClass("valid");
		            $("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
		        } else {	
			        if($val != "") {       
				        $msgTextEmpty = $('#msg-email-format').data("message");
				        $(this).removeClass("valid").addClass("not-valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgTextEmpty);		
					} else {
						$(this).removeClass("valid").removeClass("not-valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					}		        			       
		        }
		        
			},
			onInputNumberChange: function() {
				var $val = $(this).val();
				var $min = $(this).attr("min");
				var $max = $(this).attr("max");
				var expression = /^[0-9]+$/;
				
				if( expression.test($val) && $val >= parseInt($min) && $val <= parseInt($max) ) {
					$(this).removeClass("not-valid").addClass("valid");
					 $("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
				} else {
					$(this).removeClass("valid").addClass("not-valid");
					$msgNumberFormat = $('#msg-number-format').data("message");
					$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgNumberFormat + " " + $min + "-" + $max);
				}	
				
			},
			onInputPhoneChange: function() {
				var $val = $(this).val();
				var expression = /^[\+]?[(]?[0-9]{2,3}[)]?[-\s\.]?[0-9]{2,3}[-\s\.]?[0-9]{3,8}$/;
				
				if(  expression.test($val) ) {
					$(this).removeClass("not-valid").addClass("valid");
					 $("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
				} else {
					if($val != "") {
						$(this).removeClass("valid").addClass("not-valid");
						$msgPhoneFormat = $('#msg-phone-format').data("message");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgPhoneFormat);
					} else {
						$(this).removeClass("valid").removeClass("not-valid");
						$("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html("");
					}
				}	
			},
			onInputWebsiteChange: function() {
				var $val = $(this).val();
				var expression = /^(https?|ftp):\/\/[\w\-\.\_\/]+$/;
				
				if(  expression.test($val) ) {
					$(this).addClass("valid");
				} else {
					if($val != "") {
						$(this).val("http://"+$val).addClass("valid");
					} else {
						$(this).removeClass("valid");
					}
				}	
			},			
			onAddNextGroup: function(e) {
				e.preventDefault();
				$parent = $(this).parent();
				$groupContainer = $parent.find(".input-group");
				var $nextIndex = $groupContainer.data("next-index");
				$groupContainer.data("next-index", ++$nextIndex);				

				$parent.find("select").selectpicker("destroy");	
											
				$baseContainer = $parent.find(".input-group-base").html();									
				$nextContainer = $baseContainer.replace(/val1/g, "val"+$nextIndex);
				$nextContainer = $nextContainer.replace(/\(1\)/g, $nextIndex);
				$nextContainer = $nextContainer.replace(/on-focus/g, "");
				$nextContainer = $nextContainer.replace(/first-group/g, "");
				$copyGroupContainerHtml = $($nextContainer).find(".input-copy-group-container").html();								
				$nextContainer = $nextContainer.replace($copyGroupContainerHtml, "");	
						
				$parent.find(".input-copy-container").append('<div class="animateElement">'+$nextContainer+'</div>');							
	
				$parent.find("select").selectpicker('render');

			},
			onAddNextGroupInGroup: function(e) {
				e.preventDefault();
				$parent = $(this).parent();
				$groupContainer = $parent.find(".input-group");
				var $nextGroupIndex = $groupContainer.data("next-index");
				$cur_next = $nextGroupIndex+1;
				$groupContainer.data("next-index", $cur_next);					
				
				$(document).find(".new-ui-form select").selectpicker("destroy");				
				
				$baseContainer = $parent.find(".input-group-base").html();	
				$nextContainer = $baseContainer.replace(/next_group1/g, "next_group" + $cur_next);
				$nextContainer = $nextContainer.replace(/on-focus/g, "");
				$nextContainer = $nextContainer.replace(/first-group/g, "");					
						
				$parent.find(".input-copy-group-container").append('<div class="animateElement">'+$nextContainer+'</div>');	
				
				$(document).find(".new-ui-form select").selectpicker('render');
						
			},
			onRemoveGroup: function(e) {
				e.preventDefault();
				$parent = $(this).parent().fadeOut("normal", function() {
			        $(this).parent().remove();
			    });
			},
			checkEmptyRequiredInputs: function() {
				$msgTextEmpty =$('#msg-text-empty').data("message");
				
				$('.new-ui-form input, .new-ui-form select').each(function(){
				    if( !$(this).val() && $(this).hasClass("required") && $(this).is( ":visible" ) ) {
					    $(this).addClass("not-valid");
					    $("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgTextEmpty);
					    Forms.isValid = false;
				    }
				});
			},
			checkEmptyRequiredSelects: function() {
				$msgTextEmpty =$('#msg-text-empty').data("message");
				
				$('.new-ui-form select').each(function(){
				    if( !$(this).val() && $(this).hasClass("required") && $(this).is( ":visible" ) ) {
					    $(this).siblings("button").addClass("not-valid");
					    $("label[for='"+$(this).attr('id')+"']").siblings(".validation-message").html($msgTextEmpty);
					    Forms.isValid = false;
				    }
				});
			},
			checkEmptyRequiredRadios: function() {
				$msgTextEmpty =$('#msg-text-empty').data("message");
				
				$('.new-ui-form input[type="radio"]').each(function(){			
					
				    if( !$("input[name='"+$(this).attr('name')+"']:checked").val() && $(this).hasClass("required") && $(this).is( ":visible" ) ) {				    

						$msgContainer = $(this).siblings(".label-focused").find(".validation-message");
					    $msgRadioEmpty = $msgContainer.data("message");
					    $msgContainer.html($msgRadioEmpty).addClass("not-valid");
					    Forms.isValid = false;
				    }
				});
			},
			checkEmptyRequiredCheckboxs: function() {
				$('.new-ui-form input[type="checkbox"]').each(function(){			
					
				    if( !$(this).attr('checked') && $(this).hasClass("required") && $(this).is( ":visible" ) ) {				    

						$msgContainer = $(this).siblings(".label-focused").find(".validation-message");
					    $msgCheckboxEmpty = $msgContainer.data("message");
					    $msgContainer.html($msgCheckboxEmpty).addClass("not-valid");;
					    Forms.isValid = false;
				    }
				});
			},
			onInputFileChange: function() {					
					
				var filename = $(this).val();		
		        var extension = filename.replace(/^.*\./, '');	
				 
		        var validExtensions = ["pdf", "png", "jpg", "jpeg", "doc", "docx"];
		           
		        if(filename) {
			        $msgContainer = $(this).siblings(".validation-message"); 
			        if( validExtensions.indexOf(extension) != 0 ) {
						$msgTextFile = $('#msg-file-format').data("message");
						$(this).removeClass("valid").addClass("not-valid");
					    $msgContainer.html($msgTextFile);
					    Forms.isValid = false;
				    } else {
					    $(this).addClass("valid").removeClass("not-valid");
					    $msgContainer.html("");
				    }
		        } else {
			        $(this).removeClass("valid").removeClass("not-valid");
		        }
			},
			scrollToFirstInvalid: function() {
				$('html, body').stop().animate({						
	            	scrollTop: $('.not-valid:visible').first().offset().top - ($( "header.navbar" ).height() + 50)
        		}, 500, 'swing');
			},
			checkIfNotValidExist: function() {				
				if( $(".not-valid:visible").length ) {
					Forms.isValid = false;
				} else {
					Forms.isValid = true;
				}
			},
			onClickSubmitButton: function() {
				Forms.clickedButton = $(this).attr('id');
			},
			onSubmitForm: function(e) {
				e.preventDefault();					
				
				Forms.checkEmptyRequiredInputs();
				Forms.checkEmptyRequiredSelects();
				Forms.checkEmptyRequiredRadios();
				Forms.checkEmptyRequiredCheckboxs();			
									
				Forms.checkIfNotValidExist();
					
				
								
				if(Forms.isValid) {															
					
					$browser_info = navigator.userAgent.toLowerCase();
					$formData = $(this).serialize();
					$formData += '&browser_info='+encodeURI($browser_info);
/*
					var formData = $(this).find(":input")
				    .filter(function(index, element) {
				        return $(element).val() != '';
				    }).serialize();
*/
					$this = $(this);
// 					$this.find("button[type=submit]").attr("disabled","disabled");
					$this.find("button[type=submit]").prop("disabled", "disabled");
					$(".placeholder_container").fadeIn();
					$this_id = $this.attr('id');
				
					$.ajax({
					   type: "POST",
					   url: v.ajaxurl,
					   data: $formData,
					   success: function(data) {
						   						   
							if(data.status == 200) {
								Forms.notifySuccess(data.data);
								
								//reset form
								document.getElementById($this_id).reset();
								$this.find(":input").removeClass("valid");
								$(document).find(".new-ui-form select").selectpicker('render');
								$(document).find(".input-copy-container").html("");		
														
							} else if(data.status == 403) {
								Forms.notifyError("Error code: "+data.data);
								console.log(data); 
							} else {
								Forms.notifyError("Error code: "+data.message);
								 
							}							
							
							$(".placeholder_container").fadeOut();
// 							$this.find("button[type=submit]").removeAttr("disabled");
							$this.find("button[type=submit]").prop("disabled",false);
					   }
					});					
					
					
				} else {
					Forms.scrollToFirstInvalid();					
				}				
			},
			onSubmitEditUserForm: function(e) {
				e.preventDefault();					
				
				Forms.checkEmptyRequiredInputs();
				Forms.checkEmptyRequiredSelects();
				Forms.checkEmptyRequiredRadios();
				Forms.checkEmptyRequiredCheckboxs();			
									
				Forms.checkIfNotValidExist();					
								
				if(Forms.isValid) {															
					
					$formData = $(this).serialize();

					$this = $(this);
					$this.find("button[type=submit]").prop("disabled", "disabled");
					$(".placeholder_container").fadeIn();
					$this_id = $this.attr('id');
				
					$.ajax({
					   type: "POST",
					   url: v.ajaxurl,
					   data: $formData,
					   success: function(data) {
						   						   
							if(data.status == 200) {
								Forms.notifySuccess(data.data);													
							} else if(data.status == 403) {
								Forms.notifyError("Error code: "+data.data);
							} else {
								Forms.notifyError("Error code: "+data.message);
							}							
							
							$(".placeholder_container").fadeOut();
							$this.find("button[type=submit]").prop("disabled",false);
					   }
					});					
					
					
				} else {
					Forms.scrollToFirstInvalid();					
				}	
			},
			onSubmitPaymentForm: function(e) {
				e.preventDefault();			
				
				var formData = new FormData(this);			
				
				Forms.checkEmptyRequiredInputs();
				Forms.checkEmptyRequiredSelects();
				Forms.checkEmptyRequiredRadios();
				Forms.checkEmptyRequiredCheckboxs();						
									
				Forms.checkIfNotValidExist();
				if(Forms.isValid) {					
					
					var formData = new FormData(this);
					
					if( $( "#authorization_file" ).length ) {
						var confirmation_doc = $('#authorization_file').prop('files')[0];  		    
						formData.append('authorization_file', confirmation_doc);
					}								
					
					$(this).find(":input")
				    .filter(function(index, element) {
					    
					    $this = $(this);
					    
					    if( $this.val() != '' ) {			   
						    formData.append($this.attr('id'), $this.val());
					    }
				    });  
				    
				    $browser_info = navigator.userAgent.toLowerCase();
				    formData.append('browser_info', $browser_info);
				    					
					$this = $(this);
					$this.find("button[type=submit]").attr("disabled","disabled");
					$(".placeholder_container").fadeIn();
					$this_id = $this.attr('id');
					
					$.ajax({
				        url: v.ajaxurl,
				        type: "POST",
				        dataType: "JSON",
				        data: formData,
				        cache: false,
						contentType: false,
						processData: false,
				        success: function (data, status) {
							if(data.status == 200) {
								Forms.notifySuccess(data.data.msg);
															
								//reset form
								$(".placeholder_container").fadeOut();
								$this.find("button[type=submit]").removeAttr("disabled");
								document.getElementById($this_id).reset();								
								$this.find(":input").removeClass("valid");
								$(document).find(".new-ui-form select").selectpicker('render');
																
								if( data.data.link && (Forms.clickedButton == "savenpay") ) {
									window.location.href = data.data.link;
								} else {
									window.location.href = "/dziekujemy-za-przeslanie-formularza-do-weryfikacji/";
								}
							
							} else if(data.status == 403) {
								Forms.notifyError("Error: "+data.data);
								$(".placeholder_container").fadeOut();
								$this.find("button[type=submit]").removeAttr("disabled");
								
								
								
							} else {
								
								if(data.message == "Należy dodać plik potwierdzający autoryzacje lub link do pliku" || data.message == "Please upload a file confirming authorisation or provide a url link") {
									$("#authorization_file").addClass("not-valid");									
								} 
								Forms.notifyError("Error: "+data.message);
								$(".placeholder_container").fadeOut(); 
								$this.find("button[type=submit]").removeAttr("disabled");
							}
				        },
				        error: function (xhr, desc, err) {				
							console.log( err );
				        }
				    });    			
					
					
				} else {
					Forms.scrollToFirstInvalid();					
				}				
			},
			currNotify : null,		
			notifySuccess: function(msg) {
				if(Forms.currNotify != null)
					Forms.currNotify.close();
				
				var $not = $.notify({ 
					message: msg
				},{ 
					type: 'success',
					delay: 10000,
					allow_dismiss: true,
					placement: {
						from: "top",
						align: "center"
					}, 	
					z_index: 1051,	
					animate: {
						enter: 'animated fadeInDown',
						exit: 'animated fadeOutUp'
					},
				});
	
				Forms.currNotify = $not;
			},
			notifyError: function(msg) {
				if(Forms.currNotify != null)
					Forms.currNotify.close();
				
				var $not = $.notify({ 
					message: msg
				},{ 
					type: 'danger',
					delay: 10000,
					allow_dismiss: true,
					placement: {
						from: "top",
						align: "center"
					},
					z_index: 1051,
					animate: {
						enter: 'animated fadeInDown',
						exit: 'animated fadeOutUp'
					},
				}); 
				Forms.currNotify = $not;
			}		
		}
		Forms.init();
      	
  });  
	 

})(jQuery);
